<template>
	<div>
		<!--注册-->
		<div id="register" v-show="userAgreement==0">
		<mt-header title="注册" fixed>
		   <a href="javascript:void(0)" slot="left" @click="btnToLogin">
			    <mt-button icon="back" class="font-Yahei"></mt-button>
		   </a>
		</mt-header>
		 <div class="mt40">
			<p class="text-center pt45"><img src="../../../static/images/logo.png" alt="LOGO" width="90"/></p>
		 </div>
		 <!--手机号-->
		 <section class="loginContent" v-show="!showsetmmpage">
		 	<div v-if="showInput==0">
			 	<div class="login_line">
					<i class="logIco"><img src="../../../static/images/my_ico.png"/></i>
					<input type="tel" placeholder="输入手机号" maxlength="11" v-model="phone" @input="inputPhone"/>
				</div>
				<p><input type="button" value="获取验证码" class="btnRegOk" :class="{disableColor:disableds==true}" @click="btnRegOk" :disabled="disableds"/></p>
				<p class='regText' @click='btnToLogin'>已有账号，去登录</p>
			</div>
			<div v-if="showInput==1">
			  <div class="login_line">
				<i class="logIco"><img src="../../../static/images/phone_ico.png"/></i>
				<input type="number" placeholder="手机验证码" v-model="vcode" maxlength="6"/>
				<button class="btnSend" @click="sendCode" :disabled="disabled">
				   <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
	               <span v-if="!sendMsgDisabled">发送验证码</span>
				</button>
			  </div>
			  <!--<p class="ml10 pt5"><input type="radio" name="agree" :checked="checkeds" class="mr5 vm agreeRadio" @click="agreeRadio"/><label class="vm color666 font-size7">已阅读并同意《<router-link to="/UserCenter/userProtocol" class="color1ABC9C">用户服务协议</router-link>》</label></p>-->
			  <!--<p class="ml10 pt5"><input type="radio" name="agree" :checked="checkeds" class="mr5 vm agreeRadio" @click="agreeRadio"/><label class="vm color666 font-size7">已阅读并同意《<span @click="showAgreement" class="color1ABC9C">用户服务协议</span>》</label></p>-->
			  <p class="pt5"><input type="button" value="下一步" class="btnReg" @click="btnRegnext" :disabled="disabledss"/></p>
			</div>
		 </section>
		 <!--密码-->
		 <section class="loginContent"  v-show="showsetmmpage">
			<div >
			  <div class="login_linem">
				<i class="logIco"><img src="../../../static/images/password_login.png"/></i>
				<input :type="typepasswardo" placeholder="请设置登录密码" v-model="passward" maxlength="20"/>
				<i @click="changetypeo" class="logIco2"><img :src="srcopeno"/></i>
			  </div>
			  <!--<p class="ml10 pt5"><input type="radio" name="agree" :checked="checkeds" class="mr5 vm agreeRadio" @click="agreeRadio"/><label class="vm color666 font-size7">已阅读并同意《<router-link to="/UserCenter/userProtocol" class="color1ABC9C">用户服务协议</router-link>》</label></p>-->
			  <p class="ml10 pt5"><input type="radio" name="agree" :checked="checkeds" class="mr5 vm agreeRadio" @click="agreeRadio"/><label class="vm color666 font-size7">已阅读并同意《<span @click="showAgreement" class="colorF8B377">用户服务协议</span>》</label></p>
			  <p class="pt5"><input type="button" value="注册" class="btnReg" :class="{disableColor:checkeds==false}" @click="btnReg" :disabled="disabledss"/></p>
			</div>
		 </section>
		</div>

		<!--用户协议-->
		<div id="userprotocol" v-show="userAgreement==1">
			<mt-header title="用户协议"  fixed>
				  <a href="javascript:void(0)" slot="left" @click="bucktoregister">
				    <mt-button icon="back" class="font-Yahei"></mt-button>
				  </a>
			</mt-header>
			<div class="font-size8 color666 pro_textbox">
				<p class="pt20 text-indent24">本协议是您与“盈卡商城”的所有者“深圳市盈华讯方通信技术有限公司”（以下简称为“盈卡商城”）之间就盈卡商城所提供的服务及相关事宜所立订的契约，请您仔细阅读本注册协议，在您确认阅读并选择注册后，本协议即构成对双方有约束力的法律文件。</p>
			    <p class="color4DBCAA mt10">第一条 盈卡商城服务条款的确认和接纳</p>
			    <p class="pt10">1.盈卡商城的各项电子服务的所有权和运作权归“盈卡商城”所有。客户同意所有注册协议条款并完成注册程序，才能成为盈卡商城的正式客户。客户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</p>
			    <p>2.客户点击同意本协议的，即视为客户确认自己具有享受盈卡商城服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。</p>
			    <p>3.如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用盈卡商城。</p>
			    <p>4.“盈卡商城”保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭客户账户、清除或编辑内容或取消订单的权利。</p>
			    <p class="color4DBCAA mt10">第二条 法律管辖和适用</p>
			    <p class="pt10">本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生盈卡商城服务条款与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。 如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。</p>
			    <p class="color4DBCAA mt10">第三条 盈卡商城服务</p>
			    <p class="pt10">1.盈卡商城通过互联网依法为客户提供互联网信息等服务，客户在完全同意本协议及盈卡商城规定的情况下，方有权使用盈卡商城的相关服务。 </p>
			    <p>2.客户必须自行准备如下设备和承担如下开支：</p>
			    <p>（1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；</p>
			    <p>（2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</p>
			    <p class="color4DBCAA mt10">第四条 客户信息</p>
			    <p class="pt10">1.客户应自行诚信向盈卡商城提供注册资料，客户同意其提供的注册资料真实、准确、完整、合法有效，客户注册资料如有变动的，应及时更新其注册资料。如果客户提供的注册资料不合法、不真实、不准确、不详尽的，客户需承担因此引起的相应责任及后果，并且“盈卡商城”保留终止客户使用“盈卡商城”各项服务的权利。</p>
			    <p>2.客户在盈卡商城进行浏览、下单购物等活动时，涉及客户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，盈卡商城将予以严格保密，除非得到客户的授权或法律另有规定，盈卡商城不会向外界披露客户隐私信息。</p>
			    <p>3.客户注册成功后，将产生客户名和密码等账户信息，您可以根据盈卡商城规定改变您的密码。客户应谨慎合理的保存、使用其客户名和密码。客户若发现任何非法使用客户账号或存在安全漏洞的情况，请立即通知盈卡商城并向公安机关报案。</p>
			    <p>4.客户同意，“盈卡商城”拥有通过邮件、短信电话等形式，向在盈卡商城注册、购物客户、收货人发送订单信息、促销活动等告知信息的权利。</p>
			    <p>5.客户不得将在盈卡商城注册获得的账户借给他人使用，否则客户应承担由此产生的全部责任，并与实际使用人承担连带责任。</p>
			    <p class="color4DBCAA mt10">第五条 客户依法言行义务</p>
			    <P class="pt10">本协议依据国家相关法律法规规章制定，客户同意严格遵守以下义务：</P>
			    <p>1.不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；</p>
			    <p>2.从中国大陆向境外传输资料信息时必须符合中国有关法规；</p>
			    <P>3.不得利用盈卡商城从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</P>
			    <p>4.不得干扰盈卡商城的正常运转，不得侵入盈卡商城及国家计算机信息系统；</p>
			    <P>5.不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；</P>
			    <P>6.不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</P>
			    <P>7.不得教唆他人从事本条所禁止的行为；</P>
			    <P>8.不得利用在盈卡商城注册的账户进行牟利性经营活动；</P>
			    <P>9.不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；</P>
			    <P>盈卡商城保有删除站内各类不符合法律政策或不真实的信息内容而无须通知客户的权利。</P>
			    <p>若客户未遵守以上规定的，盈卡商城有权作出独立判断并采取暂停或关闭客户帐号等措施。客户须对自己在网上的言论和行为承担法律责任。</p>
			    <p class="color4DBCAA mt10">第六条 商品信息</p>
			    <p class="pt10">盈卡商城上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，盈卡商城不作特别通知。由于网站上商品信息的数量极其庞大，虽然盈卡商城会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，盈卡商城网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；“盈卡商城”欢迎纠错，并会视情况给予纠错者一定的奖励。</p>
			    <p class="color4DBCAA mt10">第七条 订单</p>
			    <p class="pt10">1.在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与客户本人不一致的，收货人的行为和意思表示视为客户的行为和意思表示，客户应对收货人的行为及意思表示的法律后果承担连带责任。</p>
			    <p>2.除法律另有强制性规定外，双方约定如下：盈卡商城上销售方展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向销售方发出的合同要约；销售方收到该订单信息后，已将货物实际直接向您发出时，方视为您与销售方之间就发出的货物建立了合同关系；如果您在一份订单里订购了多种商品并且销售方只给您发出了部分商品时，您与销售方之间仅就实际向您发出的商品建立了合同关系。</p>
			    <p>3.由于市场变化及各种以合理商业努力难以控制的因素的影响，盈卡商城无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品，发生缺货，您有权取消订单。</p>
			    <p class="color4DBCAA mt10">第八条 配送</p>
			    <P class="pt10">1.盈卡商城将会把商品（货物）送到您所指定的收货地址，所有在盈卡商城上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。</P>
			    <p>2.因如下情况造成订单延迟或无法配送等，盈卡商城将无法承担延迟配送的责任：</p>
			    <P>（1）客户提供的信息错误、地址不详细等原因导致的；</P>
			    <p>（2）货物送达后无人签收，导致无法配送或延迟配送的；</p>
			    <p>（3）情势变更因素导致的；</p>
			    <P>（4）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。</P>
			    <p class="color4DBCAA mt10">第九条 责任限制及不承诺担保</p>
			    <P class="pt10">1.除非另有明确的书面说明,盈卡商城及其所包含的或以其它方式通过盈卡商城提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。</P>
			    <p>2.除非另有明确的书面说明,“盈卡商城”不对盈卡商城的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</p>
			    <p>3.“盈卡商城”不担保盈卡商城所包含的或以其它方式通过盈卡商城提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从盈卡商城发出的电子信件、信息没有病毒或其他有害成分。</p>
			    <p>4.如因不可抗力或其它盈卡商城无法控制的原因使盈卡商城销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，“盈卡商城”会合理地尽力协助处理善后事宜。</p>
			    <p class="color4DBCAA mt10">第十条 所有权及知识产权条款</p>
			    <P class="pt10">1.8.1客户一旦接受本协议，即表明该客户主动将其在任何时间段在盈卡商城发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给“盈卡商城”所有，客户同意“盈卡商城”有权就任何主体侵权而单独提起诉讼。</P>
			    <p>2.8.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权转让书面协议，其效力及于客户在“盈卡商城”上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</p>
			    <P>3.8.3客户同意并已充分了解本协议的条款，承诺不将已发表于盈卡商城的信息，以任何形式发布或授权其它主体以任何方式使用（包括但限于在各类网站、媒体上使用）。</P>
			    <p>4.8.4“盈卡商城”是盈卡商城的制作者,拥有此网站内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及盈卡商城的内容进行修改，并在盈卡商城张贴，无须另行通知客户。在法律允许的最大限度范围内，“盈卡商城”对本协议及盈卡商城内容拥有解释权。</p>
			    <p>5.8.5除法律另有强制性规定外，未经“盈卡商城”明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用盈卡商城的信息内容，否则，“盈卡商城”有权追究其法律责任。</p>
			    <p>6.8.6盈卡商城所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是“盈卡商城”或其内容提供者的财产，受中国和国际版权法的保护。盈卡商城上所有内容的汇编是“盈卡商城”的排他财产，受中国和国际版权法的保护。盈卡商城上所有软件都是“盈卡商城”或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。</p>
			    <p class="color4DBCAA mt10">第十一条 协议更新及客户关注义务</p>
			    <p class="pt10">1.“盈卡商城”尊重客户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为客户和消费者提供服务。同时盈卡商城也会根据国家法律法规变化、网站运营需要及客户建议适时修改本协议及盈卡商城上的各类规则。</p>
			    <p>2.协议修改后一旦被张贴在盈卡商城上即生效，并代替原来的协议。客户可随时登录查阅最新协议；客户有义务不时关注并阅读最新版的协议及网站公告。如客户不同意更新后的协议，可以且应立即停止接受盈卡商城网站依据本协议提供的服务；如客户继续使用本网站提供的服务的，即视为同意更新后的协议。盈卡商城建议您在使用盈卡商城之前阅读本协议及盈卡商城的公告。</p>
			    <p>如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
			    <p class="mt30">请您务必认真阅读本协议并充分理解协议中相关条款内容，尤其是以下划线标识的重要条款。如您对协议有任何疑问，可向平台客服咨询。阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { Toast } from 'mint-ui'
	import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
			   time: 60, // 发送验证码倒计时
               sendMsgDisabled: false,
               disabled:false,
               showInput:0,
               //showInputid:this.$route.query.showInput,   //点击用户协议传过来的id
               phone:"",
               vcode:"",
               passward:"",
               disableds:true,
               checkeds:false,
               disabledss:false,
               userAgreement:0, //显示注册，协议页面参数
               typepasswardo:'password',
               srcopeno:'../../../static/images/closeeye.png',
               showsetmmpage:false,
               movableType:this.$route.query.movableType,//渠道号 1.移动商城   2.电话钱包网   3.微信公众号
               cname:this.Act_Cname,//活动类名
               md5sign:this.Act_md5sign,
			}
		},
		created:function(){
	    },
	    methods: {
	    	btnToLogin(){
	    		this.$router.push({path: "/Login",query:this.$route.query});
	    	},
	    	//协议返回函数
	    	bucktoregister(){
	    	    this.userAgreement=0;
	    	},
	    	changetypeo(){
	           if(this.typepasswardo=='password'){
	           	 this.typepasswardo='text';
	           	 this.srcopeno='../../../static/images/openeye.png';
	           }else{
	           	 this.typepasswardo='password';
	           	 this.srcopeno='../../../static/images/closeeye.png';
	           }
	        },
	    	//输入手机号
	    	inputPhone(){
	    		if(this.phone.length==11){
	    			this.disableds=false;
	    		}else{
	    			this.disableds=true;
	    		}
	    	},
	    	//是否同意协议
	    	agreeRadio(){
	    		if(this.checkeds){
	    			this.checkeds=false;
	    			this.disabledss=true;
	    		}else{
	    			this.disabledss=false;
	    			this.checkeds=true;
	    		}
	    	},
	    	//是否显示用户协议
	    	showAgreement(){
	    	    this.userAgreement=1;
	    	},
	    	//发送验证码按钮
	     	sendCode(){
	     		var signM=md5('phone_num='+this.phone+'&'+this.md5sign);
	     		if(this.validatePhone()){
	     			Indicator.open();
			        this.$http.post(this.URL_PREFIX+"/user/sendVerCode.net",{phone_num:this.phone,sign:signM})
				  	.then((res) =>{
				  		Indicator.close();
				  		if(res.data.code!=200){
				  			Toast(res.data.msg);
				  		}else{
				  			Toast(res.data.msg);
				  			let me = this;
					        me.sendMsgDisabled = true;
					        me.disabled=true;
					        this.showInput=1;
					        let interval = window.setInterval(function(){
					          if ((me.time--) <= 0) {
					            me.time = 60;
					            me.sendMsgDisabled = false;
					            me.disabled=false;
					            window.clearInterval(interval);
					          }
					        }, 1000);
						}
				  	});
	     		}
	     	},
	     	//输入手机号确认按钮
	     	btnRegOk(){
	     		if(this.validatePhone()){
	     		    this.sendCode();
	     		}else{
	     			this.showInput=0;
	     		}
	     	},
	     	//下一步按钮
	     	btnRegnext(){
	     	  if(this.vcode==""){
	     	  	 Toast("请输入手机验证码");
	     	  }else{
	     	  	this.$http.post(this.URL_PREFIX+"/user/regUser.net",{uName:this.phone,verCode:this.vcode})
			  	.then((res) =>{
			  	    if(res.data.code==200){
			  	    	//console.log(11111);
//			  	       Toast(res.data.msg);
			  	       localStorage.setItem('username',this.phone);
//			  	       this.$router.push(this.$route.query.redirect || '/');
                       this.showsetmmpage=true;
			  	    }else{
			  	       Toast(res.data.msg);
			  	    }
			  	});
	     	  }
	     	},
	     	//注册按钮
	     	btnReg(){
	     	  var signR=md5('uName='+this.phone+'&pwd='+this.passward+'&'+this.md5sign);
	     	  if(this.validatepassword()){
		     	  if(this.checkeds==false){
		     	     Toast("请阅读用户服务协议");
		     	  }else{
		     	  	if(this.movableType==""||this.movableType==null){
		     	  		this.movableType=0;
		     	  	}
		     	  	Indicator.open();
		     	  	this.$http.post(this.URL_PREFIX+"/user/regUser.net",{uName:this.phone,pwd:this.passward,sign:signR,movableType:this.movableType,cname:this.cname})
				  	.then((res) =>{
				  		Indicator.close();
				  	    if(res.data.code==200){
				  	       Toast(res.data.msg);
				  	       localStorage.setItem('username',this.phone);
				  	       if(this.movableType==1||this.movableType==3){
				  	       	  this.$router.push({path: "/Ticket/lucky?movableType="+this.movableType});//渠道号 1.移动商城   2.电话钱包网   3.微信公众号	  	       	
				  	       }else if(this.movableType==2){
				  	       	  this.$router.push({path: "/Ticket/luckyPC?movableType="+this.movableType});
				  	       }else{
				  	       	  this.$router.push(this.$route.query.redirect || '/');
				  	       }				  	       
				  	    }else{
				  	       Toast(res.data.msg);
				  	    }
				  	});
		     	  }
	     	  }
	     	},
	     	//手机号验证
	     	validatePhone(){
	     		var reg=/^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;;
	     		if(this.phone==''){
                    Toast("请输入手机号码");
                   return false;
                }else if(!reg.test(this.phone)){
                    Toast("手机号格式不正确");
                    return false;
                }else{
                	return true;
                }
	     	},
	     	//登录密码验证
	     	validatepassword(){
	     		var reg= /^[a-zA-Z0-9\W_!@#$%^&*`~()-+=?]{6,20}$/
	     		var reg2 = /\s+/g;
	     		var reg3 = /[\u4E00-\u9FFF]/g;
	     		var reg4 = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
	     		if(this.passward==''){
                    Toast("请输入新密码");
                   return false;
                }else if(reg2.test(this.passward)){
                   Toast("新密码不能包含空格");
                   return false;
                }else if(!reg.test(this.passward)){
                    Toast("新密码必须为6-20位字母、数字或符号");
                    return false;
                }else if(reg3.test(this.passward)){
                    Toast("新密码不能包含中文");
                    return false;
                }else if(reg4.test(this.passward)){
                    Toast("新密码不能包含中文符号");
                    return false;
                }else{
                	return true;
                }
	     	}
	    }
	}
</script>

<style scoped="scoped">
@import "../../../static/css/user.css";
.login_linem{border: 1px solid #e0e0e0 ;padding: 10px;margin-bottom: 10px;overflow: hidden;border-radius: 5px;-webkit-border-radius: 5px;}
.login_linem input{float:left;width: 70%;color: #333;font-size: 1.0rem;border: none;background: transparent;line-height: 30px;margin-left: 20px;}
.pro_textbox{width: 90%;margin: 40px auto;}
.pro_textbox p{line-height: 25px;}
.color4DBCAA{color: #333;font-size: 1.0rem;}
.text-indent24{text-indent: 24px;}
.logIco2{width: 20px;height: 20px;margin-top: 3px;float:right;}
.logIco2 img{width: 100%;}
.regText{cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/views/Register/index.vue